<section class="terms-page animate-fade-in-up" aria-label="Terms of Service">
    <div class="terms-page__container">
        <div class="terms-page__title">Terms of Service</div>
        <div class="terms-page__revision">Revision: {{ revisionDate }}</div>

        <div class="terms-page__content">
            <article class="terms-page__block">
                <div class="terms-page__block-title">1. Service Agreements</div>
                <div class="terms-page__block-copy">
                    Access to Rêve platforms and subsequent consulting services implies agreement to these structural
                    terms. Custom Master Service Agreements (MSAs) will supersede these general terms.
                </div>
            </article>

            <article class="terms-page__block">
                <div class="terms-page__block-title">2. Intellectual Property (IP)</div>
                <div class="terms-page__block-copy">
                    All AI deflection algorithms, agentic logic flows, and proprietary ISV frameworks remain the
                    exclusive intellectual property of Rêve Cloud Inc. Client data processed by these models remains the
                    exclusive property of the client.
                </div>
            </article>
        </div>
    </div>
</section>